import { render, staticRenderFns } from "./Blockchains.vue?vue&type=template&id=543147d7&scoped=true&"
import script from "./Blockchains.vue?vue&type=script&lang=ts&"
export * from "./Blockchains.vue?vue&type=script&lang=ts&"
import style0 from "./Blockchains.vue?vue&type=style&index=0&id=543147d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543147d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
